import React, { useState, useEffect } from "react"
import PageTitle from "../common/PageTitle"
import OrderDisplay from "./OrderDisplay"
import OrderNumber from "./OrderNumber"
import ProofOfPayment from "./ProofOfPayment"
import PaymentMethodDisplay from "./PaymentMethodDisplay"
import ShippingDisplay from "./ShippingDisplay"
import OrderProducts from "./OrderProducts"
import UploadProof from "./UploadProof"
import CheckoutFooter from "../CheckoutFooter"
import Amounts from "../common/Amounts"
import "./OrderConfirmation.css"
import pixel from "../../landing/pixel"

function OrderConfirmation({
  orderData,
  subTotal,
  grandTotal,
  updateOrderData,
  setOnlinePaymentDetails,
  //for Amounts
  tax,
  daysLeft
}) {
  const [uploadBoxShown, setUploadBox] = useState(false)
  function toggleUploadBox() {
    setUploadBox(!uploadBoxShown)
  }

  useEffect(() => {
    pixel.track("AddPaymentInfo")
  })

  const deliveryAddress =
    (orderData &&
      !orderData.is_pickup &&
      orderData.order_address.delivery_address.address) ||
    orderData.order_address.pickup_address.address
  const contactPerson =
    (orderData &&
      !orderData.is_pickup &&
      orderData.order_address.delivery_address.contact_person) ||
    orderData.order_address.pickup_address.name

  const isPaid = orderData.payment_status === "paid"

  const paymentType =
    (orderData.payment_gateway[0] &&
      orderData.payment_gateway[0].payment_type) ||
    null

  return (
    <div className="OrderConfirmation">
      <PageTitle businessname={orderData.businessname} />
      {orderData && (
        <OrderDisplay isPaid={isPaid} daysLeft={daysLeft}>
          <div className="border-bottom">
            <OrderNumber
              orderNumber={orderData.order_number}
              paymentStatus={orderData.payment_status}
              paymentDetail={orderData.payment_detail}
              isRefunded={orderData.payment_status === "refunded"}
            />
            {!isPaid &&
              ((paymentType !== "online" ||
                orderData.payment_gateway[0].gateway_code === "GC" ||
                orderData.payment_gateway[0].gateway_code === "PAYMP") && (
                <ProofOfPayment
                  handleButtonClick={toggleUploadBox}
                  paymentDetail={orderData.payment_detail}
                  isRefunded={orderData.payment_status === "refunded"}
                />
              ))}
          </div>

          {orderData.payment_gateway &&
            orderData.payment_gateway.length > 0 && (
              <PaymentMethodDisplay
                gateway={orderData.payment_gateway[0]}
                orderData={orderData}
                grandTotal={grandTotal}
                setOnlinePaymentDetails={setOnlinePaymentDetails}
              />
            )}

          {orderData.order_address && (
            <ShippingDisplay
              isPickup={orderData.is_pickup}
              name={
                orderData.is_pickup
                  ? contactPerson
                  : `${
                      contactPerson.firstname
                        ? contactPerson.firstname
                        : orderData.customer_info.firstname
                    } ${
                      contactPerson.lastname
                        ? contactPerson.lastname
                        : orderData.customer_info.lastname
                    }`
              }
              addressOne={
                deliveryAddress.city
                  ? [
                      deliveryAddress.address_line_1,
                      deliveryAddress.address_line_2,
                      deliveryAddress.barangay,
                      deliveryAddress.city
                    ]
                  : [
                      orderData.customer_info.address.address_line_1,
                      orderData.customer_info.address.address_line_2,
                      orderData.customer_info.address.barangay,
                      orderData.customer_info.address.city
                    ]
              }
              addressTwo={
                deliveryAddress.country
                  ? [
                      deliveryAddress.zipcode,
                      deliveryAddress.province,
                      deliveryAddress.country
                    ]
                  : [
                      orderData.customer_info.address.zipcode,
                      orderData.customer_info.address.province,
                      orderData.customer_info.address.country
                    ]
              }
              pickupInstructions={
                orderData.order_address.pickup_address.instruction
              }
            />
          )}

          {(orderData.products || orderData.custom_products) &&
            [...orderData.products, ...orderData.custom_products].length >
              0 && (
              <OrderProducts
                products={orderData.products}
                customProducts={orderData.custom_products}
                currency={orderData.currency}
                orderData={orderData}
              />
            )}
          <Amounts
            orderData={orderData}
            subTotal={subTotal}
            tax={tax}
            discountAmount={(orderData && orderData.discount_amount) || null}
            shippingRate={(orderData && orderData.shipping_fee) || 0}
            deliveryMethodName={
              (orderData && orderData.delivery_method) || null
            }
            taxDetails={
              (orderData &&
                orderData.tax_percentage && {
                  name: orderData.tax_name,
                  percentage: orderData.tax_percentage
                }) ||
              null
            }
            isTaxInclusive={orderData && orderData.is_tax_inclusive}
          />
        </OrderDisplay>
      )}
      <CheckoutFooter businessName={orderData && orderData.businessname} />
      {uploadBoxShown && (
        <UploadProof
          toggleUploadBox={toggleUploadBox}
          orderUUID={orderData.uuid}
          paymentDetail={orderData.payment_detail}
          updateOrderData={updateOrderData}
          isRefunded={orderData.payment_status === "refunded"}
        />
      )}
    </div>
  )
}

export default OrderConfirmation
